import { AxiosInstance } from 'axios';
import config from 'config/Config';
import { initAxios } from 'utils/axios';
import { NewGoalData } from 'utils/types/strategyGoals';

class StrategyGoalsAPI {
  instance: AxiosInstance;
  constructor() {
    this.instance = initAxios(`${config.get('backendURL')}v2/strategy/goals`);
  }

  fetchStrategyGoals = async (filters?: any) => {
    let url = '/';
    const queryParams: string[] = [];

    if (filters) {
      filters.timePeriod &&
        queryParams.push(`timePeriod=${filters.timePeriod}`);
      filters.year && queryParams.push(`year=${filters.year}`);
    }
    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }
    const res = await this.instance.get(url);
    return res;
  };

  fetchOwnersList = async () => {
    const res = await this.instance.get('/possible-owners');
    return res;
  };

  fetchTeamsList = async () => {
    const res = await this.instance.get('/possible-ld-teams');
    return res;
  };

  createStrategyGoal = async (newGoalData: NewGoalData) => {
    const res = await this.instance.post('/', newGoalData);
    return res;
  };

  fetchGoalsProgress = async (goalIds: string[]) => {
    const res = await this.instance.post('/project-progress-summary', {
      goalIds,
    });
    return res.data;
  };
}

const strategyGoalsAPI = new StrategyGoalsAPI();

export default strategyGoalsAPI;
